import { useAutocompleteContext } from './context'
import { type AutocompleteItemApi, type AutocompleteResult } from './types'

export function useAutocompleteItem(result: AutocompleteResult): AutocompleteItemApi {
  const register = useAutocompleteContext()
  return register(result)
}
